// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__3vxjB","frontpage":"Navigation_frontpage__2yPpl"};